/**
 * Report cards dropped from the website (Jeff, 2026-10), and what replaced them.
 *
 * - 89  "Intake Study" (`intake-study-2`): a second Intake Study row the server
 *   never implemented (ReportDispatcher no-op). Intake Study is RS 94.
 * - 133 "Production Audit" (`production-audit`): no generator anywhere, no
 *   tblRS_Report row. Nothing replaces it.
 * - 135 "Meal Pattern Notes" (`meal-pattern-notes-report`): no generator, no
 *   tblRS_Report row. Meal Pattern Notes is RS 140.
 *
 * The server can still return rows for these keys (tblRS_Report keeps 89), and
 * saved favorites (`tblPM_User_ReportFavorite`), recent runs
 * (`tblRS_ReportDocument.FKey_RS_Report`) and bookmarks may still point at
 * them. Those are mapped onto the replacement card; nothing is shown for 133.
 *
 * Small on purpose: imported by the favorites key module and the recents hook,
 * which must not pull in `reportConfigs.ts`.
 */

/** RS keys whose cards no longer exist. The catalog never shows them. */
export const RETIRED_REPORT_PKEYS: ReadonlySet<number> = new Set([89, 133, 135]);

/** Retired RS key -> the RS key of the card that replaced it. */
export const RETIRED_REPORT_REPLACEMENT: Readonly<Record<number, number>> = {
  89: 94, // Intake Study
  135: 140, // Meal Pattern Notes
};

/** Retired slug -> replacement slug (bookmarks, deep links, legacy favorites). */
export const RETIRED_REPORT_SLUGS: Readonly<Record<string, string>> = {
  'intake-study-2': 'intake-study',
  'meal-pattern-notes-report': 'meal-pattern-notes',
};

/** The RS key a report key now stands for: the replacement for a retired key, else itself. */
export function currentReportPKey(pKey: number): number {
  return RETIRED_REPORT_REPLACEMENT[pKey] ?? pKey;
}
